const ReviewProductLookupMode = Object.freeze({
    DISABLED: 'disabled',
    ORGANIZATION_PRODUCTS: 'organization-products',
    SUPPLIER_PRODUCTS: 'supplier-products',
})

const SUPPORTED_MODES = Object.freeze(Object.values(ReviewProductLookupMode))

const normalizeProductSuggestion = product => {
    if (!product || typeof product !== 'object') {
        return null
    }

    const productId = product.productId || product.id || null
    const name = product.name || product.title || product.productName || product.label || ''
    const identifier = product.identifier || product.code || ''

    if (productId === null || typeof productId === 'undefined') {
        return null
    }

    return {
        productId: String(productId),
        name: name ? String(name) : null,
        identifier: identifier ? String(identifier) : null,
        raw: product,
    }
}

const processSupplierId = process => {
    const externalContext = process && process.externalContext
    const metadata = externalContext && externalContext.metadata

    return metadata && metadata.supplierId ? metadata.supplierId : null
}

const resolveReviewProductLookup = ({ profile, context = {}, process = null } = {}) => {
    const profileConfig = profile && profile.productLookup ? profile.productLookup : {}
    const runtimeConfig = context && context.productLookup ? context.productLookup : {}
    const allowedModes = Array.isArray(profileConfig.allowedModes)
        ? profileConfig.allowedModes.filter(mode => SUPPORTED_MODES.includes(mode))
        : SUPPORTED_MODES
    const requestedMode = runtimeConfig.mode || profileConfig.defaultMode || ReviewProductLookupMode.DISABLED
    const mode = allowedModes.includes(requestedMode)
        ? requestedMode
        : ReviewProductLookupMode.DISABLED
    const supplierId = runtimeConfig.supplierId || processSupplierId(process)
    const preferredProductId = runtimeConfig.preferredProductId !== null
        && typeof runtimeConfig.preferredProductId !== 'undefined'
        ? String(runtimeConfig.preferredProductId)
        : null
    const searchAdapter = typeof runtimeConfig.search === 'function'
        ? runtimeConfig.search
        : null
    const available = mode !== ReviewProductLookupMode.DISABLED
        && !!searchAdapter
        && (mode !== ReviewProductLookupMode.SUPPLIER_PRODUCTS || !!supplierId)

    return Object.freeze({
        mode,
        supplierId: supplierId || null,
        preferredProductId,
        available,
        search(query) {
            const normalizedQuery = typeof query === 'string' ? query.trim() : ''
            if (!available || !normalizedQuery) {
                return Promise.resolve([])
            }

            return Promise.resolve(searchAdapter({
                mode,
                supplierId: supplierId || null,
                preferredProductId,
                query: normalizedQuery,
            })).then(items => (
                Array.isArray(items) ? items.map(normalizeProductSuggestion).filter(Boolean) : []
            ))
        },
    })
}

export {
    ReviewProductLookupMode,
    normalizeProductSuggestion,
    resolveReviewProductLookup,
}
